(function () {
  function initFaq(root) {
    var items = root.querySelectorAll('[data-ugc-faq-item]');
    var allowMultiple = root.dataset.allowMultiple === 'true';

    items.forEach(function (item) {
      item.addEventListener('toggle', function () {
        if (!item.open || allowMultiple) return;
        items.forEach(function (other) {
          if (other !== item) other.removeAttribute('open');
        });
      });
    });
  }

  function boot() {
    document.querySelectorAll('[data-ugc-faq-root]').forEach(initFaq);
  }

  document.addEventListener('shopify:section:load', boot);
  boot();
})();
